import React from 'react';
import {CorporateBannerComponent, CorporateInfoComponent, CorporateContactDetails, CorporateTeam} from '../../../../common/CMS/components';

export const Corporate1 = (props) => {
    const {corporateBanner, corporateInfo, corporateContact, corporateMembers  } = props.data.content;

    return ( 
        <div className="corporate-one">

            { corporateBanner && <CorporateBannerComponent content={corporateBanner} /> }

            { corporateInfo && <CorporateInfoComponent content={corporateInfo} /> }

            { corporateContact && <CorporateContactDetails content={corporateContact} /> }

            { corporateMembers && <CorporateTeam content={corporateMembers} /> }

        </div>
    )
};



// WEBPACK FOOTER //
// src/client/components/site/features/partnerships/templates/Corporate1.js